import React                from "react";
import Action               from "Dashboard/Core/Action";
import Navigate             from "Dashboard/Core/Navigate";
import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import TitleEdit            from "./TitleEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import TablePaging          from "Dashboard/Components/Table/TablePaging";



/**
 * The Title List
 * @returns {React.ReactElement}
 */
function TitleList() {
    const { fetch, load } = useList("title");

    const data = Store.useState("title");
    const { loading, canEdit, list, total, sort } = data;

    // The Current State
    const [ action, elemCode, startAction, endAction ] = Action.useActionCode();


    // Handles the Action
    const handleAction = (action, elemCode) => {
        if (action.isView) {
            const elemUrl = Utils.getValue(list, "titleCode", elemCode, "image");
            Navigate.gotoUrl(elemUrl, true);
        } else {
            startAction(action, elemCode);
        }
    };

    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };


    // Do the Render
    return <Main>
        <Header message="TITLES_NAME" icon="title">
            <ActionList data={data} onAction={handleAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="TITLES_NONE_AVAILABLE"
                isLoading={loading}
                hasTabs
            >
                <TableHead>
                    <TableHeader field="name"  message="GENERAL_NAME"  isTitle />
                    <TableHeader field="image" message="GENERAL_IMAGE" />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.titleCode} elemID={elem.titleCode}>
                        <TableCell message={elem.name}  />
                        <TableCell message={elem.image} />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={handleAction} canEdit={canEdit}>
                    <TableAction action="EDIT" message="TITLES_EDIT_TITLE" />
                    <TableAction action="VIEW" message="TITLES_VIEW_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <TitleEdit
            open={action.isVCE}
            elemCode={elemCode}
            onSubmit={handleEdit}
            onClose={endAction}
        />
    </Main>;
}

export default TitleList;
